var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{key:_vm.lang,attrs:{"app":"","id":"app"}},[_c('header-component'),_c('payment-alert'),_c('v-main',{attrs:{"id":"main"}},[_c('router-view'),_c('Confirm',{ref:"confirm"}),_c('SubscriptionLockDialog'),_c('div',{attrs:{"id":"fb-root"}})],1),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }